import { Col, Row } from "@/common/css";
import Icon from "@/common/ui/Image";
import { SideBarContentHeader } from "@/common/ui/SideBar";
import { H3, LightText2 } from "@/common/ui/Text";
import { SETTINGS_NAVBAR_LINKS } from "@/utils/constant/global.constant";
import React from "react";
import { Link } from "react-router-dom";

const SettingLandingPage: React.FC = () => {
  return (
    <div className="px-2 md:px-4">
      <SideBarContentHeader heading="Settings" />
      <Row className=" py-4 !gap-6 flex-col md:flex-row w-full md:w-auto md:flex-wrap">
        {SETTINGS_NAVBAR_LINKS.map((link) => {
          return (
            <Link to={link.path} key={link.path} className="w-full md:w-auto">
              <Row className="border border-stroke-light rounded-llg  p-3 md:!p-5 gap-3 w-full md:min-w-330">
                <Icon src={link.icon} alt="" />
                <Col className=" gap-1">
                  <H3 text={link.name} />
                  <LightText2 text={link.description} />
                </Col>
              </Row>
            </Link>
          );
        })}
      </Row>
    </div>
  );
};

export default SettingLandingPage;
